import styled from 'styled-components';

export const PageViewport = styled.main`
  background-color: ${(props) => props.theme['color.background']};
  flex: 1 1 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: ${(props) => props.isPositionRelative && 'relative' };

  ${(props) => props.centered && `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 30px 30px 10px;
  `}

  ${(props) => props.displayFlexColumn && `
    display: flex;
    flex-direction: column;
  `}
`;
